import AuthService from '../../business-api/AuthService'

import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'

import NUMMIN from '../NumMinMax/NumMin'

import NUMMAX from '../NumMinMax/NumMax'

import TAMMAX from '../TamMax/TamMax'

import {
    formataArrayData,
    formataArrayDataHora,
} from '../../business-components/Date/Date'

import {
    formataValor,
    formataCelular,
} from '../../business-components/Formata/Formata'

import {
    pesquisaDescricaoList,
    incluiCampoList,
} from './ListService'

import perfilList from './perfilList'

import simNaoList from './simNaoList'

import tipoLicencaList from './Assinatura/tipoLicencaList'

import ufList from './ufList'



export const camposUsuarioEstatisticaList = ( list, columnsExibe, grafico, filtroList, filtroLists, variaveisGlobais ) => {

    let camposListAux = []

    const isUsuarioLogadoFintracks = AuthService.isUsuarioLogadoFintracks(variaveisGlobais)

    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'email',
        label: LABEL.email,
        filtro: 'S',
        filtroGrafico: 'N',
        type: HARDCODE.typeEmail,
        tamMax: HARDCODE.email,
        numMin: null,
        numMax: null,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 10,
    })

    if (isUsuarioLogadoFintracks) {

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'dataHoraInclusao',
            label: LABEL.dataHoraInclusao,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeDataHora,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: null,
            columnsDefault: 'S',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (formataArrayDataHora(list[dataIndex].dataHoraInclusao))
                },
            },
            permiteAgrupar: 'N',
            permiteGerarPDFQuebra: 'N',
            ordem: 20,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'dataInicioFreetrack',
            label: LABEL.dataInicioFreetrack,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeData,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: null,
            columnsDefault: 'S',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (formataArrayData(list[dataIndex].dataInicioFreetrack))
                },
            },
            permiteAgrupar: 'N',
            permiteGerarPDFQuebra: 'N',
            ordem: 30,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'freetrack',
            label: LABEL.freetrack,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeInteiro,
            tamMax: null,
            numMin: NUMMIN.anos,
            numMax: NUMMAX.anos,
            list: null,
            columnsDefault: 'S',
            options: null,
            permiteAgrupar: 'N',
            permiteGerarPDFQuebra: 'N',
            ordem: 40,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'assinante',
            label: LABEL.assinante,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeListMultiSelectString,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: filtroLists.assinanteLists,
            columnsDefault: 'S',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (pesquisaDescricaoList(simNaoList, list[dataIndex].assinante))
                },
            },
            permiteAgrupar: 'S',
            permiteGerarPDFQuebra: 'N',
            ordem: 45,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'dataAssinaturaModuloBase',
            label: LABEL.dataAssinaturaModuloBase,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeData,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: null,
            columnsDefault: 'S',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (formataArrayData(list[dataIndex].dataAssinaturaModuloBase))
                },
            },
            permiteAgrupar: 'N',
            permiteGerarPDFQuebra: 'N',
            ordem: 50,
        })
    }

    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'perfil',
        label: LABEL.perfil,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeListMultiSelectString,
        tamMax: null,
        numMin: null,
        numMax: null,
        list: filtroLists.perfilLists,
        columnsDefault: 'S',
        options: {
            customBodyRenderLite: (dataIndex) => {
                return (pesquisaDescricaoList(perfilList, list[dataIndex].perfil))
            },
        },
        permiteAgrupar: 'S',
        permiteGerarPDFQuebra: 'N',
        ordem: 60,
    })

    if (isUsuarioLogadoFintracks) {

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'tipoLicenca',
            label: LABEL.tipoLicenca,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeListMultiSelectString,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: filtroLists.tipoLicencaLists,
            columnsDefault: 'S',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (pesquisaDescricaoList(tipoLicencaList, list[dataIndex].tipoLicenca))
                },
            },
            permiteAgrupar: 'S',
            permiteGerarPDFQuebra: 'N',
            ordem: 70,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'razaoSocial',
            label: LABEL.razaoSocial,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeStringLike,
            tamMax: TAMMAX.razaoSocial,
            numMin: null,
            numMax: null,
            list: null,
            columnsDefault: 'S',
            options: null,
            permiteAgrupar: 'N',
            permiteGerarPDFQuebra: 'N',
            ordem: 80,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'cidade',
            label: LABEL.cidade,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeListMultiSelectString,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: filtroLists.cidadeLists,
            columnsDefault: 'S',
            options: null,
            permiteAgrupar: 'S',
            permiteGerarPDFQuebra: 'N',
            ordem: 90,
        })
        
        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'uf',
            label: LABEL.uf,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeListMultiSelectString,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: filtroLists.ufLists,
            columnsDefault: 'S',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (pesquisaDescricaoList(ufList(true), list[dataIndex].uf))
                },
            },
            permiteAgrupar: 'S',
            permiteGerarPDFQuebra: 'N',
            ordem: 100,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'grupo',
            label: LABEL.grupo,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeListMultiSelectString,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: filtroLists.grupoLists,
            columnsDefault: 'S',
            options: null,
            permiteAgrupar: 'S',
            permiteGerarPDFQuebra: 'N',
            ordem: 110,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'subgrupo',
            label: LABEL.subgrupo,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeListMultiSelectString,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: filtroLists.subgrupoLists,
            columnsDefault: 'S',
            options: null,
            permiteAgrupar: 'S',
            permiteGerarPDFQuebra: 'N',
            ordem: 120,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'responsavelPersistencia',
            label: LABEL.responsavelPersistencia,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeListMultiSelectString,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: filtroLists.responsavelPersistenciaLists,
            columnsDefault: 'S',
            options: null,
            permiteAgrupar: 'S',
            permiteGerarPDFQuebra: 'N',
            ordem: 125,
        })

    }
    
    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'ativo',
        label: LABEL.ativo,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeListMultiSelectString,
        tamMax: null,
        numMin: null,
        numMax: null,
        list: filtroLists.ativoLists,
        columnsDefault: 'S',
        options: {
            customBodyRenderLite: (dataIndex) => {
                return (pesquisaDescricaoList(simNaoList, list[dataIndex].ativo))
            },
        },
        permiteAgrupar: 'S',
        permiteGerarPDFQuebra: 'N',
        ordem: 130,
    })

    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'qtdeClientes',
        label: LABEL.qtdeClientes,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeInteiro,
        tamMax: null,
        numMin: NUMMIN.qtdeClientes,
        numMax: NUMMAX.qtdeClientes,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 140,
    })

    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'qtdeTransacoes',
        label: LABEL.qtdeTransacoes,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeInteiro,
        tamMax: null,
        numMin: NUMMIN.qtdeTransacoes,
        numMax: NUMMAX.qtdeTransacoes,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 150,
    })
    
    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'qtdeTransacoes30dias',
        label: LABEL.qtdeTransacoes30dias,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeInteiro,
        tamMax: null,
        numMin: NUMMIN.qtdeTransacoes,
        numMax: NUMMAX.qtdeTransacoes,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 160,
    })

    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'qtdeTransacoes15dias',
        label: LABEL.qtdeTransacoes15dias,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeInteiro,
        tamMax: null,
        numMin: NUMMIN.qtdeTransacoes,
        numMax: NUMMAX.qtdeTransacoes,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 170,
    })
    
    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'qtdeTransacoes7dias',
        label: LABEL.qtdeTransacoes7dias,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeInteiro,
        tamMax: null,
        numMin: NUMMIN.qtdeTransacoes,
        numMax: NUMMAX.qtdeTransacoes,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 180,
    })
    
    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'qtdeTransacoes3dias',
        label: LABEL.qtdeTransacoes3dias,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeInteiro,
        tamMax: null,
        numMin: NUMMIN.qtdeTransacoes,
        numMax: NUMMAX.qtdeTransacoes,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 190,
    })
    
    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'qtdeTransacoes2dias',
        label: LABEL.qtdeTransacoes2dias,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeInteiro,
        tamMax: null,
        numMin: NUMMIN.qtdeTransacoes,
        numMax: NUMMAX.qtdeTransacoes,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 200,
    })

    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'qtdeTransacoes2dias',
        label: LABEL.qtdeTransacoes2dias,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeInteiro,
        tamMax: null,
        numMin: NUMMIN.qtdeTransacoes,
        numMax: NUMMAX.qtdeTransacoes,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 210,
    })
    
    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'qtdeTransacoes1dia',
        label: LABEL.qtdeTransacoes1dia,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeInteiro,
        tamMax: null,
        numMin: NUMMIN.qtdeTransacoes,
        numMax: NUMMAX.qtdeTransacoes,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 220,
    })
    
    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'qtdeTransacoesHoje',
        label: LABEL.qtdeTransacoesHoje,
        filtro: 'S',
        filtroGrafico: 'S',
        type: HARDCODE.typeInteiro,
        tamMax: null,
        numMin: NUMMIN.qtdeTransacoes,
        numMax: NUMMAX.qtdeTransacoes,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 230,
    })

    if (isUsuarioLogadoFintracks) {

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'dataHoraUltimoAcesso',
            label: LABEL.dataHoraUltimoAcesso,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeDataHora,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: null,
            columnsDefault: 'S',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (formataArrayDataHora(list[dataIndex].dataHoraUltimoAcesso))
                },
            },
            permiteAgrupar: 'N',
            permiteGerarPDFQuebra: 'N',
            ordem: 233,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'diasUltimoAcesso',
            label: LABEL.diasUltimoAcesso,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeInteiro,
            tamMax: null,
            numMin: NUMMIN.dias,
            numMax: NUMMAX.dias,
            list: null,
            columnsDefault: 'S',
            options: null,
            permiteAgrupar: 'N',
            permiteGerarPDFQuebra: 'N',
            ordem: 236,
        })
    }

    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'nome',
        label: LABEL.nome,
        filtro: 'S',
        filtroGrafico: 'N',
        type: HARDCODE.typeStringLike,
        tamMax: TAMMAX.nome,
        numMin: null,
        numMax: null,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 240,
    })
    
    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'nomeCurto',
        label: LABEL.nomeCurto,
        filtro: 'S',
        filtroGrafico: 'N',
        type: HARDCODE.typeStringLike,
        tamMax: TAMMAX.nomeCurto,
        numMin: null,
        numMax: null,
        list: null,
        columnsDefault: 'S',
        options: null,
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 250,
    })

    incluiCampoList({
        camposList: camposListAux,
        columnsExibe: columnsExibe,
        grafico: grafico,
        filtroList: filtroList,
        name: 'celular',
        label: LABEL.celular,
        filtro: 'S',
        filtroGrafico: 'N',
        type: HARDCODE.typeCelular,
        tamMax: null,
        numMin: null,
        numMax: null,
        list: null,
        columnsDefault: 'S',
        options: {
            customBodyRenderLite: (dataIndex) => {
                return (formataCelular(list[dataIndex].celular))
            },
        },
        permiteAgrupar: 'N',
        permiteGerarPDFQuebra: 'N',
        ordem: 260,
    })

    if (isUsuarioLogadoFintracks) {

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'dataInicioCobranca',
            label: LABEL.dataInicioCobranca,
            filtro: 'S',
            filtroGrafico: 'N',
            type: HARDCODE.typeData,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: null,
            columnsDefault: 'S',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (formataArrayData(list[dataIndex].dataInicioCobranca))
                },
            },
            permiteAgrupar: 'N',
            permiteGerarPDFQuebra: 'N',
            ordem: 270,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'dataUltimaCobrancaAte',
            label: LABEL.dataUltimaCobrancaAte,
            filtro: 'S',
            filtroGrafico: 'N',
            type: HARDCODE.typeData,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: null,
            columnsDefault: 'S',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (formataArrayData(list[dataIndex].dataUltimaCobrancaAte))
                },
            },
            permiteAgrupar: 'N',
            permiteGerarPDFQuebra: 'N',
            ordem: 280,
        })
        
        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'dataPrecoModuloBaseAtual',
            label: LABEL.dataPrecoModuloBaseAtual,
            filtro: 'S',
            filtroGrafico: 'N',
            type: HARDCODE.typeData,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: null,
            columnsDefault: 'S',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (formataArrayData(list[dataIndex].dataPrecoModuloBaseAtual))
                },
            },
            permiteAgrupar: 'N',
            permiteGerarPDFQuebra: 'N',
            ordem: 280,
        })

        incluiCampoList({
            camposList: camposListAux,
            columnsExibe: columnsExibe,
            grafico: grafico,
            filtroList: filtroList,
            name: 'precoModuloBaseAtual',
            label: LABEL.precoModuloBaseAtual,
            filtro: 'S',
            filtroGrafico: 'S',
            type: HARDCODE.typeValor,
            tamMax: null,
            numMin: null,
            numMax: null,
            list: null,
            columnsDefault: 'S',
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (formataValor(list[dataIndex].precoModuloBaseAtual, 2))
                },
            },
            permiteAgrupar: 'N',
            permiteGerarPDFQuebra: 'N',
            ordem: 290,
        })
    }

    return camposListAux
}

export default camposUsuarioEstatisticaList